<main class="new-chat-panel" aria-label="New conversation panel" [formGroup]="form">
  <header class="recipient-bar" aria-label="Recipient selection">
	<!-- Recipient chips and search input build the participant list for the new channel request. -->
    <span class="recipient-bar__label">To:</span>
    <div class="recipient-bar__input-wrap">
      @for (person of selectedRecipients(); track person.email) {
        <span class="recipient-pill">
          {{ person.name | titlecase}}
          <button type="button" class="recipient-pill__remove" (click)="onRemoveRecipient(person.email)" [attr.aria-label]="'Remove ' + person.name">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </span>
      }

      <input
        type="search"
        placeholder="Enter name or email"
        formControlName="search"
        autocomplete="off"
      />
    </div>
    <button
      type="button"
      class="recipient-bar__toggle"
      [attr.aria-label]="showSuggestions() ? 'Collapse list' : 'Expand list'"
      [attr.aria-expanded]="showSuggestions()"
      (click)="toggleSuggestions()"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
    <button
      type="button"
      class="recipient-bar__close"
      aria-label="Close new chat"
      (click)="onClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  @if (showSuggestions()) {
	<!-- Suggestions are filtered locally from the shared user list loaded by Home. -->
    <section class="recipient-suggestions" aria-label="Suggested recipients">
      @if (filteredPeople().length) {
        @for (person of filteredPeople(); track person.email) {
          <button class="recipient-item" type="button" (click)="onSelectPerson(person)">
            <span class="recipient-item__avatar" [style.--avatar-accent]="getPersonAccent(person)">{{ person.initials }}</span>
            <span class="recipient-item__meta">
              <strong>{{ person.name | titlecase}}</strong>
              <small>{{ person.email }}</small>
            </span>
          </button>
        }
      } @else {
        <p class="recipient-empty">No matches found</p>
      }
    </section>
  }

  @if (selectedRecipients().length === 0) {
	<!-- Before any recipient is chosen, keep the right side in a guided empty state. -->
    <section class="new-chat-empty" aria-label="New conversation empty state">
      <div class="new-chat-empty__logo" aria-hidden="true">
        <mat-icon>brush</mat-icon>
      </div>
      <h2>You're starting a new conversation</h2>
      <p>Select at least one recipient to begin typing your message.</p>
    </section>
  } @else {
	<!-- After recipients are selected, this area becomes a draft thread plus first-message composer. -->
    <section class="new-chat-thread" aria-label="Draft conversation">
      <section class="message-list" aria-label="Draft messages">
        @if (sentMessages().length) {
          @for (message of sentMessages(); track $index) {
            <article class="message message--own">
              <div class="message__body">
                <div class="message__meta">
                  <strong>You</strong>
                  <time>{{ message.time }}</time>
                </div>
                <div class="message__bubble">
                  <p>{{ message.text }}</p>
                </div>
              </div>
            </article>
          }
        } @else {
          <p class="new-chat-thread__hint">Write your first message to get the conversation started.</p>
        }
      </section>

      <footer class="composer" aria-label="New message composer">
        <div class="composer__row">
          <div class="composer__tools">
            <button class="icon-button" type="button" aria-label="Attach file">
              <span class="material-icons">attach_file</span>
            </button>
            <div class="composer__emoji" (click)="onEmojiPickerClick($event)">
              <button class="icon-button" type="button" aria-label="Insert emoji" [attr.aria-expanded]="isEmojiPickerOpen()" (click)="toggleEmojiPicker($event)">
                <span class="material-icons">sentiment_satisfied</span>
              </button>

              @if (isEmojiPickerOpen()) {
                <div class="composer__emoji-picker" role="dialog" aria-label="Emoji picker">
                  <emoji-picker preview-position="none" skin-tone-emoji="👍" (emoji-click)="onEmojiPicked($event)"></emoji-picker>
                </div>
              }
            </div>
          </div>

          <label class="composer__input">
            <textarea
              #messageBox
              rows="1"
              placeholder="Type a new message"
              [formControl]="messageControl"
              (keydown.enter)="$event.preventDefault(); onSendMessage()"
            ></textarea>

            <button
              class="send-button"
              type="button"
              aria-label="Send message"
              [disabled]="!messageControl.value.trim()"
              (click)="onSendMessage()"
            >
              <span class="material-icons">send</span>
            </button>
          </label>

          <div class="composer__status" aria-live="polite" aria-hidden="true"></div>
        </div>
      </footer>
    </section>
  }
</main>
